import { request, localConfig, combineUrl } from '~/common';

const membershipRequest = (params, callback, action) => {
    return request(combineUrl(localConfig.obtApiUrl, `Membership/V1/json/${action}`), params, callback);
}

export function saveUserSetting(params, callback) {
    return membershipRequest(params, callback, 'SaveUserSetting');
}

export function searchTravelerSummary(params, callback) {
    return membershipRequest(params, callback, 'searchtravelersummary');
}

